import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UsuarioDTOModel } from 'src/app/account/models/usuario-dto.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private $loginData = new BehaviorSubject<UsuarioDTOModel>(null);

  setLoginData(loginData: UsuarioDTOModel): void {
    this.$loginData.next(loginData);
  }

  getLoginData(): Observable<UsuarioDTOModel> {
    return this.$loginData.asObservable();
  }

  clear(): void {
    this.$loginData.next(null);
  }

}
